import { useEffect, useState } from 'react';

const Downloader = ({ trigger }) => {
	const [deferredPrompt, setDeferredPrompt] = useState(null);

	useEffect(() => {
		const handleBeforeInstallPrompt = (e) => {
			e.preventDefault();
			setDeferredPrompt(e);
		};

		//This event is automatically triggered once a page is loaded
		//only if app has never been installed.
		//It will never be triggered if app has already been installed.
		window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

		//Don't know why it constantly raises uncaught exception
		//Hiding it from user console by using .catch
		const handleClickInstall = () => {
			deferredPrompt.prompt().catch(() => {
				return;
			});
		};

		if (trigger && deferredPrompt) {
			handleClickInstall();
		}
	}, [deferredPrompt, setDeferredPrompt, trigger]);

	return null;
};

export default Downloader;
